/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PaymentHistory} from '../../core/_models'

type Props = {
  PaymentHistory: PaymentHistory
}

const PaymentHistoryValue: FC<Props> = ({PaymentHistory}) => {
  let toFormat: any = PaymentHistory.amount_paid?.toString()

  const CurrencyValue = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(toFormat)

  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 fw-semibold fs-7 mb-1'>
          {CurrencyValue}
        </a>
      </div>
    </div>
  )
}

export {PaymentHistoryValue}
